import React from 'react';
import styled from 'styled-components';

import loadingIcon from '../assets/images/loading.svg';
import { useStoreState } from '../store';
import { PlayerStatus } from '../typings';
import { isSmartTV } from '../utils/tv';

const isTV = isSmartTV();

export function LoadingOverlay() {
  const playerReady = useStoreState((state) => state.player.playerReady);
  const status = useStoreState((state) => state.player.status);
  const castState = useStoreState((state) => state.chromecast.castState);
  const error = useStoreState((state) => state.error.error);

  const hasStartedPlayback = status === PlayerStatus.Playing || status === PlayerStatus.Paused;
  const isBuffering = status === PlayerStatus.Buffering;
  const isCastConnecting = castState === 'CONNECTING';
  const isLoading = !error && (!playerReady || !hasStartedPlayback || isBuffering || isCastConnecting);

  if (!isLoading) return null;

  return (
    <Container>
      <LoadingIcon src={loadingIcon} />
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const LoadingIcon = styled.img`
  width: ${isTV ? '134px' : '88px'};
  height: ${isTV ? '134px' : '88px'};
  animation: spin 1s linear infinite;
`;
